export default [
    {
        path: '/payIndex',
        name: 'payIndex',
        component: () => import('@/views/pay/index.vue'),
        meta: {
            title: '首页'
        }
    },
    {
        path: '/vipPackageIndex',
        name: 'vipPackageIndex',
        component: () => import('@/views/pay/vipPackage/index.vue'),
        meta: {
            title: 'vip套餐管理'
        }
    },
    {
        path: '/payLog',
        name: 'payLog',
        component: () => import('@/views/pay/log/payLog.vue'),
        meta: {
            title: '订单列表'
        }
    },
    {
        path: '/vipUserList',
        name: 'vipUserList',
        component: () => import('@/views/pay/vipUser/index.vue'),
        meta: {
            title: 'vipUser列表'
        }
    },
    {
      path: '/pay/vipPackage/productIdView',
      name: 'pay/vipPackage/productIdView',
      component: () => import('@/views/pay/vipPackage/productIdView.vue'),
      meta: {
        title: '订阅产品ID'
      }
    },
]



// WEBPACK FOOTER //
// ./src/router/payRouter.js